import { Typography } from '@material-ui/core';

import {
  ConfidenceWebsiteLink,
  DialogComposite,
  MultiStepDialog,
  useFormField,
} from '@spotify/confidence-core-react';
import {
  AverageMeasurementFormFields,
  MeasurementFormValues,
  RatioMeasurementFormFields,
  StepId,
} from '@spotify/plugin-confidence-metrics-react';

type AggregationStepProps = {
  stepId?: string;
};

export const AggregationStep = ({
  stepId = StepId.Aggregation,
}: AggregationStepProps) => {
  const { value: metricType } = useFormField<
    MeasurementFormValues,
    'metricType'
  >('metricType');
  const { value: typeSpec } = useFormField<MeasurementFormValues, 'typeSpec'>(
    'typeSpec',
  );

  const isAverageType =
    metricType === 'average' ||
    metricType === 'conversion' ||
    metricType === 'consumption';
  const isRatioType = metricType === 'ratio' || metricType === 'ctr';

  const canProceed = Boolean(
    (isAverageType && typeSpec?.averageMetricSpec?.aggregation) ||
      (isRatioType &&
        typeSpec?.ratioMetricSpec?.numeratorAggregation &&
        typeSpec?.ratioMetricSpec?.denominatorAggregation),
  );

  return (
    <MultiStepDialog.Step id={stepId}>
      <MultiStepDialog.Header>
        <Typography variant="h4" component="h4">
          Aggregation
        </Typography>
        <DialogComposite.Subtitle>
          Select the way you want to aggregate facts into your measurement.{' '}
          <ConfidenceWebsiteLink
            route="/docs/metrics#within-entity-aggregation"
            underline="always"
          >
            Learn more.
          </ConfidenceWebsiteLink>
        </DialogComposite.Subtitle>
      </MultiStepDialog.Header>
      <MultiStepDialog.Body>
        {isAverageType && <AverageMeasurementFormFields />}
        {isRatioType && <RatioMeasurementFormFields />}
      </MultiStepDialog.Body>
      <MultiStepDialog.Actions>
        <MultiStepDialog.Actions.Prev />
        <MultiStepDialog.Actions.Next disabled={!canProceed} />
      </MultiStepDialog.Actions>
    </MultiStepDialog.Step>
  );
};
